var reviewsio_widget = {
	settings: {
		wrapper_class: '.reviews-main__wrapper',
		wrapper_load_element: 'reviews-main__wrapper_load',
		dynamic_root_element: '.ElementsWidget__list'
	},
	preload: function () {
		var root = this;
		var settings = root.settings;
		var load_interval = setInterval(function () {

			if ($(settings.dynamic_root_element).length) {
				clearInterval(load_interval);
				$(window).resize(function () {
					clearTimeout($.data(this, 'reviewsio_widget_resizeTimer'));
					$.data(this, 'reviewsio_widget_resizeTimer', setTimeout(function () {
						root.viewport_logic();
					}, 250));
				});
				root.viewport_logic();
			}
		}, 1000);
	},
	viewport_logic: function () {
		var root = this;
		var settings = root.settings;
		$(settings.wrapper_class).removeClass(settings.wrapper_load_element);
	},
	init: function () {
		var root = this;
		root.preload();
	}
};

reviewsio_widget.init();

// REVIEWS IO Widget 
var data_product_sku = $('.reviewsio-widget').attr('data-product-sku');
var reviews_widget_type = '';

var reviewsIoChecker = {
	settings: {
		product_sku: data_product_sku,
	},
	load_reviews_widget: function () {
		new ReviewsWidget('#ReviewsWidget', {
			store: 'wearefeel.com',
			widget: 'polaris',
			
			//Content settings (store_review,product_review,third_party_review,questions). Choose what to display in this widget:
			options: {
				types: reviews_widget_type,
				// types: 'product_review,store_review,third_party_review',
				lang: 'en',
				layout: '',
				per_page: 6,
				store_review: {
					hide_if_no_results: true,
					tag: 'en'
				},
				third_party_review: {
					hide_if_no_results: true,
				},
				product_review: {
					sku: data_product_sku,
					enable_rich_snippets: false,
				},
				/* Toggle Options */
				questions: {
					hide_if_no_results: false,
					enable_ask_question: true,
					show_dates: true
				},
				
				//Header settings:
				header: {
					enable_summary: false, //Show overall rating & review count
					enable_ratings: true,
					enable_attributes: false,
					enable_image_gallery: false, //Show photo & video gallery
					enable_percent_recommended: false, //Show what percentage of reviewers recommend it
					enable_write_review: false, //Show "Write Review" button
					enable_ask_question: false, //Show "Ask Question" button
					enable_sub_header: true, //Show subheader
					rating_decimal_places: 2,
				},
				
				//Filtering settings:
				filtering: {
					enable: true, //Show filtering options
					enable_text_search: false, //Show search field
					enable_sorting: true, //Show sorting options (most recent, most popular)
					enable_media_filter: false, //Show reviews with images/video/media options
					enable_overall_rating_filter: true, //Show overall rating breakdown filter
					enable_language_filter: false, // Filter by review language
					enable_language_filter_language_change: false, // Update widget language based on language selected
					enable_ratings_filters: false, //Show product attributes filter
					enable_attributes_filters: false, //Show author attributes filter
				},
				
				//Review settings:
				reviews: {
					default_sort: "highest_rating",
					enable_avatar: false, //Show author avatar
					enable_reviewer_name: true, //Show author name
					enable_reviewer_address: false, //Show author location
					reviewer_address_format: 'city, country', //Author location display format
					enable_verified_badge: true, //Show "Verified Customer" badge
					review_content_filter: 'undefined', //Filter content
					enable_reviewer_recommends: false, //Show "I recommend it" badge
					enable_attributes: false, //Show author attributes
					enable_product_name: true, //Show display product name
					enable_review_title: undefined, //Show review title
					enable_replies: undefined, //Show review replies
					enable_images: true, //Show display review photos
					enable_ratings: true, //Show product attributes (additional ratings)
					enable_share: true, //Show share buttons
					enable_helpful_vote: false, //Show "was this helpful?" section
					enable_helpful_display: true, //Show how many times times review upvoted
					enable_report: false, //Show report button
					enable_date: true, //Show when review was published
				},
			},
			//Translation settings
			translations: {
				'Verified Customer': 'Verified Customer'
			},
			//Style settings:
			styles: {
				//Base font size is a reference size for all text elements. When base value gets changed, all TextHeading and TexBody elements get proportionally adjusted.
				'--base-font-size': '16px',
				
				//Button styles (shared between buttons):
				'--common-button-font-family': 'inherit',
				'--common-button-font-size': '16px',
				'--common-button-font-weight': '500',
				'--common-button-letter-spacing': '0',
				'--common-button-text-transform': 'none',
				'--common-button-vertical-padding': '10px',
				'--common-button-horizontal-padding': '20px',
				'--common-button-border-width': '2px',
				'--common-button-border-radius': '0px',
				
				//Primary button styles:
				'--primary-button-bg-color': '#0E1311',
				'--primary-button-border-color': '#0E1311',
				'--primary-button-text-color': '#ffffff',
				
				//Secondary button styles:
				'--secondary-button-bg-color': 'transparent',
				'--secondary-button-border-color': '#0E1311',
				'--secondary-button-text-color': '#0E1311',
				
				//Star styles:
				'--common-star-color': '#0E1311',
				'--common-star-disabled-color': 'rgba(0,0,0,0.25)',
				'--medium-star-size': '22px',
				'--small-star-size': '19px',
				
				//Heading styles:
				'--heading-text-color': '#0E1311',
				'--heading-text-font-weight': '600',
				'--heading-text-font-family': 'inherit',
				'--heading-text-line-height': '1.4',
				'--heading-text-letter-spacing': '0',
				'--heading-text-transform': 'none',
				
				//Body text styles:
				'--body-text-color': '#0E1311',
				'--body-text-font-weight': '400',
				'--body-text-font-family': 'inherit',
				'--body-text-line-height': '1.4',
				'--body-text-letter-spacing': '0',
				'--body-text-transform': 'none',
				
				//Input field styles:
				'--inputfield-text-font-family': 'inherit',
				'--input-text-font-size': '14px',
				'--inputfield-text-font-weight': '400',
				'--inputfield-text-color': '#0E1311',
				'--inputfield-border-color': 'rgba(0,0,0,0.2)',
				'--inputfield-background-color': 'transparent',
				'--inputfield-border-width': '1px',
				'--inputfield-border-radius': '0px',
				
				'--common-border-color': 'rgba(0,0,0,0.15)',
				'--common-border-width': '1px',
				'--common-sidebar-width': '190px',
				
				//Slider indicator (for attributes) styles:
				'--slider-indicator-bg-color': 'rgba(0,0,0,0.1)',
				'--slider-indicator-button-color': '#0E1311',
				'--slider-indicator-width': '190px',
				
				//Badge styles:
				'--badge-icon-color': '#0E1311',
				'--badge-icon-font-size': 'inherit',
				'--badge-text-color': '#0E1311',
				'--badge-text-font-size': 'inherit',
				'--badge-text-letter-spacing': 'inherit',
				'--badge-text-transform': 'inherit',
				
				//Author styles:
				'--author-font-size': 'inherit',
				'--author-text-transform': 'none',
				
				//Author avatar styles:
				'--avatar-thumbnail-size': '60px',
				'--avatar-thumbnail-border-radius': '100px',
				'--avatar-thumbnail-text-color': '#0E1311',
				'--avatar-thumbnail-bg-color': 'rgba(0,0,0,0.1)',
				
				//Product photo or review photo styles:
				'--photo-video-thumbnail-size': '80px',
				'--photo-video-thumbnail-border-radius': '0px',
				
				//Media (photo & video) slider styles:
				'--mediaslider-scroll-button-icon-color': '#0E1311',
				'--mediaslider-scroll-button-bg-color': 'rgba(255, 255, 255, 0.85)',
				'--mediaslider-overlay-text-color': '#ffffff',
				'--mediaslider-overlay-bg-color': 'rgba(0, 0, 0, 0.8))',
				'--mediaslider-item-size': '110px',
				
				//Pagination & tabs styles (normal):
				'--pagination-tab-text-color': '#0E1311',
				'--pagination-tab-text-transform': 'none',
				'--pagination-tab-text-letter-spacing': '0',
				'--pagination-tab-text-font-size': '16px',
				'--pagination-tab-text-font-weight': '600',
				
				//Pagination & tabs styles (active):
				'--pagination-tab-active-text-color': '#0E1311',
				'--pagination-tab-active-text-font-weight': '600',
				'--pagination-tab-active-border-color': '#0E1311',
				'--pagination-tab-border-width': '3px',
			},
		});
	},
	request: function() {		
		var root = this;
		var settings = root.settings;
		var product_random_version = Math.floor(Math.random() * 1000000000);
		var request_url = 'https://api.reviews.io/product/rating-batch';
		var request_params = {
			store: 'wearefeel.com',
			sku: settings.product_sku,
			v: '=' + product_random_version
		};
		$.ajax({
			url: request_url,
			type: 'GET',
			data: request_params,
			success: function(element, data) {
					root.rating_output(data, element);							
			}.bind(this, settings.current_element)
		});
	},
	rating_output: function(data, element) {
		const root = this;
		if (data !='') {
			if (data.some(item => item.lookup)) {
				var product_average_rating = 0;
				var product_num_ratings = 0;
				
				data.forEach(item => {
					if (item.lookup) {
						product_average_rating += item.num_ratings;
						product_num_ratings += item.num_ratings * parseFloat(item.average_rating);
					}
				});
				var rating = product_average_rating > 0 ? (product_num_ratings / product_average_rating).toFixed(4) : 0;
				var count = product_average_rating;
			} else {
				var rating = data[0].average_rating;
				var count = data[0].num_ratings;
			}
			
			if(count > 5 && rating >= 4 ) {
				reviews_widget_type = 'product_review';
			} else {
				reviews_widget_type = 'store_review';
			}
		} else {
			var checkUrl = window.location.href.toLowerCase();
			if ($('body').hasClass('body__index')) {
				reviews_widget_type = 'product_review,store_review';
			} else if ($('#ReviewsWidget').hasClass('reviewsio-widget-reviews-page')) {
				reviews_widget_type = 'product_review,store_review';
			} else {
				reviews_widget_type = 'store_review';
			}
		}
		root.load_reviews_widget();
	},
	init: function() {
			var root = this;
			root.request();
	}
};

reviewsIoChecker.init();
// REVIEWS IO Widget - END
/*
$( document ).ready(function() {
	/!*!//filter language on load
	function filtersLoadedCallback(mutationList, observer) {
		mutationList.forEach(function (mutation) {
			if (mutation.type === 'childList') {
				let $addedElems = $(mutation.addedNodes);
				$addedElems.each(function () {
					let dropdowns = $(this).find('.js-demo-sortdropdown');
					dropdowns.each(function () {
						let currentFilter = $(this).find('.R-TextHeading').text().trim();
						if (currentFilter === 'Language') {
							let buttons = $(this).find('.R-DropUpDownMenu__item[role="button"]');
							if (buttons) {
								buttons.each(function () {
									if ($(this).find('.R-flex-row div').text().includes('English')) {
										$(this).click();
									}
								})
							}
						}
					});
				});
			}
		});
	}

	const observer = new MutationObserver(filtersLoadedCallback);
	observer.observe(document.querySelector("#ReviewsWidget"), {childList: true, subtree: true});*!/
});*/
